import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.languageOptions = [
  {
    label: "Deutsch",
    value: "de"
  },
  {
    label: "English",
    value: "en"
  },
  {
    label: "Français",
    value: "fr"
  },
  {
    label: "Italiano",
    value: "it"
  }
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "de",
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default,
    },
    react: {
      wait: true,
      useSuspense: false
    },
    returnObjects: false,
    returnedObjectHandler: (key, value, options) => value
  });

export default i18n;
